<button class="star" (click)="chargePreference()" aria-label="choix des supports de diffusion">
    <mat-icon >star_border</mat-icon>
  </button>
  
